import { Button } from "@at/design-system-elements";
import { ThemeSelectors } from "@at/design-system-foundation";
import styled from "styled-components";

export const OrderButton = styled(Button)`
  padding-inline: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};

  @media (max-width: 450px) {
    min-width: 145px;
  }
`;
